
import React, { useState } from 'react'

import { DescContent, Ctitle, DescIcon, IconClose } from './style'

import { Modal } from 'antd-mobile'

const Explain = ({top}) => {
	const [descVisible, setDescVisible] = useState(false)
	return (
		<React.Fragment>
			<DescIcon
        style={{marginTop:top? top+'px':'50px'}}
				src={require('@/img/activity22/0.png')}
				onClick={() => setDescVisible(true)} >
					比赛<br/>说明
				</DescIcon>
			<Modal 
				visible={descVisible} 
				wrapClassName="rw-desc-modal-outer" className={'lx-desc-modal long-modal'} 
				transparent onClose={() => setDescVisible(false)}>
					<Ctitle>
						<div >比赛说明</div>
					</Ctitle>
          <IconClose onClick={() => setDescVisible(false)} />
					<DescContent>
            <div className='content'>
            <h1>一、比赛时间</h1>
            <div>2024年5月20日至2024年8月9日</div>
            <h1>比赛对象</h1>
            <div>所有用户均可参与，在比赛页面进行报名进行参赛</div>
         
            <h1>二、参赛方式</h1>
            <div><b>第一步：</b>报名参赛，市值风云App-行情-组合-第三届组合比赛-选择或创建一个组合进行参赛 </div>
            <div><b>第二步：</b>调仓，我的组合-参赛组合-右下角【调仓】-添加候选调仓-调仓 </div>
            <div><b>第三步：</b>查看排名，市值风云App-行情-组合-第三届组合比赛-大赛排行-我的本季/本周排名</div>
            <h1>三、上榜规则</h1>
            {/* <h2>周赛榜单上榜规则：符合参赛规则的用户的参赛组合在对应单周周期内涨幅排名前10即可上榜；</h2> */}
            <div>周赛榜单上榜规则：符合参赛规则的用户的参赛组合在对应单周周期内涨幅排名前3即可上榜；</div>
            {/* <div>季赛榜单上榜规则：所有用户需同时满足下面2个条件才能上季赛榜单</div> */}
            <div>季赛榜单上榜规则：符合参赛规则的用户的参赛组合在季度周期涨幅排名前10；</div>
            <div>注：季赛最终上榜（获奖）要求：每个用户的参赛组合必须在季度周期内需要累积交易达到5次及以上，未达5次则失去季赛获奖资格。</div>
            {/* <div>1）每个用户的参赛组合必须在季度周期内需要累积交易达到5次及以上</div>
            <div>2）符合参赛规则的用户的参赛组合在季度周期涨幅排名前100；</div> */}

            <h1>排名规则：</h1>
            <div>1、季赛：以季度排行榜数据为准，比赛时间内所有参赛组合的区间涨跌幅排行作为榜单，每个用户仅可选择一个组合进行参赛。季赛榜单前10名用户依次获得奖品，奖品明细见“大赛奖励”。</div>
            <div>2、周赛：以周度排行榜数据为准，以单个自然周所有参赛组合的区间涨跌幅排行作为榜单。每周的周赛榜单前3名用户依次获得奖品，奖品明细见“大赛奖励”。对于不同周期的周赛，允许同一用户反复获奖，不作限制。</div>
            <div>3、参赛组合区间涨跌幅计算规则：</div>
            <div className='red'>基准净值计算：若用户在交易日T日的交易时间内中报名参赛，则以T-1日收盘净值为该组合作为基准，计算区间涨幅；若用户在交易日T日收盘后且T+1日收盘前报名参赛，则以T日收盘净值基础，计算区间涨幅；</div>
            <div className='red'>最终净值计算：周赛的最终净值为当周最后一个交易日收盘时刻净值为收盘净值；<br/>季赛的最终净值为2024年8月9日收盘时刻净值为收盘净值；</div>
            <div>4、同一参赛组合，在不同榜单单独计算排名，即可同时获得周赛和季赛奖项。</div>
            <div>5、本次比赛一共13个比赛周期：12个周赛，1个季赛。同一比赛周期，每个用户最多获得份奖励，若某个用户在同一个比赛周期同时获得比赛奖励和邀请奖励，则以最高的那个奖励为准。</div>
            <div>6、活动一切解释权归市值风云所有。</div>
            <h1>比赛奖励</h1>
            <h2>季榜奖励（1个季赛周期：2024.5.20-2024.8.9）</h2>
            <div>冠军：第1名:华为P70＊1台＆2024款风云周边＆定制奖杯</div>
            <div>亚军：第2名:1000元京东卡＆2024款风云周边＆定制奖杯</div>
            <div>季军：第3名：200元京东卡&2024款风云周边&定制奖杯  </div>
            <div>优胜奖：第4-10名：2024款风云周边（四选一）</div>
            <h2>周榜奖励（12个周赛周期：2024.5.20-2024.8.9的每个自然周，不包含节假日周）</h2>
            <div>冠军：第1名:100元京东卡+研报畅读周卡</div>
            <div>亚军：第2名:50元京东卡+研报畅读周卡</div>

            <div>季军：第3名：研报畅读周卡 </div>
            <h2>邀请好友奖励</h2>
            <div>1、若被邀请的好友（必须是市值风云APP未注册的新用户）获得季赛/周赛奖励，则邀请人也可以获得同样奖励。</div>
            <div>2、邀请奖励：<span className='red'>被邀请的好友获得季赛前3名或周赛第一名，则获得100元京东卡奖励，被邀请的好友获得其他比赛奖励，则获得研报畅读周卡奖励。</span> </div>
            <div>3、邀请时间必须是在比赛期间，<span className='red'>且通过本次比赛页面的邀请链接或分享链接</span>才有资格获得邀请奖励机会。</div>
            <div>4、单个比赛周期（单周/单季）内，最多获得一次邀请奖励。即每个比赛周期（每周/每季）的邀请奖励为所有邀请的好友参赛组合排名最高的那个为准，即最高奖励。</div>
            <div>5、每个未注册新用户只能被邀请一次，且本人不能邀请自己。推荐官与受邀人不可为同一用户，即用户只可邀请好友，不可邀请自己（同一用户)作为被邀请人，否则参与资格与所得奖励均无效。同一用户是指包括但不限于同一登录账号、同一手机号、同一身份证号、同终端设备号、同一IP或其他合理方式显示为同一用户的情形。</div>
            <div>6、对于以任何不正当方式参与活动的用户。包括但不限于侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、批量注册、用机器注册账户、用机器模拟客户端等，市值风云有权取消其参与和获得各种奖励的资格，对于非法所得。保留将各种奖励扣回的权利，并对账号进行永久限制。</div>
            <h1>奖励发放</h1>
            <h2>实物奖励：华为P70（12+256）/定制奖杯/风云周边</h2>
            <div>参与季赛并获得季度奖前10名的用户以及其邀请者（如果有的话)可获得相应的实物奖励。风云小助手将在所有比赛完成后10个工作日天内发布获奖榜单并联系获奖人员，并在比赛完成后15天内完成发货。</div>
            <h2>非实物奖励：京东卡/研报畅读会员</h2>
            <div>获得上述奖励的用户，风云小助手将在所有比赛完成后10个工作日内发布获奖榜单并联系获奖人员，并在比赛完成后15天内完成发放。</div>
            <div>届时获奖者若有疑问，可扫描下方风云小助手二维码咨询。</div>
    
            <img src={require('@/img/activity_100/code.png')} alt=''/>
            <div className='tips'>扫码二维码，添加市值风云官方企微</div>
            <div></div>
            <h1>免责声明</h1>
            <div>投资有风险，入市需谨慎！本活动不构成且不应被视为任何购买证券或其他金融产品的协议、要约、要约邀请、意见或建议。本活动的任何内容均不构成我们在投资、法律、会计或税务方面的意见，也不构成某种投资或策略是否适合于活动参与人情况的陈述，或其他任何针对活动参与人的推荐。</div>
          </div>
          </DescContent>
			</Modal>
		</React.Fragment>
	)
}
export default Explain


// WEBPACK FOOTER //
// ./src/views/activity_100/components/explain.js